import Vue from 'vue'
import App from './App.vue'
import router from './router'
// for using bootstrapVue
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
// for using fontawesome
import '@fortawesome/fontawesome-free/css/all.css';
// shared admin-panel page chrome (toolbar/card/empty/buttons/pagination)
import '@/assets/admin-theme.css';

Vue.use(BootstrapVue);
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
